import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductCardOnDisplayInShowroom from 'components/consumer/product-card/ProductCardOnDisplayInShowroom';
import Link from 'components/consumer/Link';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardLabelUI from 'components/consumer/product-card/ProductCardLabel/ProductCardLabelUI';
import ProductCardNameUI from 'components/consumer/product-card/ProductCardNameUI';
import ProductCardPriceUI from 'components/consumer/product-card/ProductCardPrice/ProductCardPriceUI';
import IconQuickship from 'components/icons/iconQuickship';
import { colorGrayLight2 } from 'styles/layout/colors';
import useAllProductClearanceStock from 'data-hooks/useAllProductClearanceStock';
import ProductCardSwatchesNewUI from 'components/consumer/product-card/ProductCardSwatches/ProductCardSwatchesNewUI';
import ProductCardOptionsUI from 'components/consumer/product-card/ProductCardOptions/ProductCardOptionsUI';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import ProductCardPhotoSquare from './components/ProductCardPhotoSquare';
import ProductCardFavoriteButton from './components/ProductCardFavoriteButton';
import { isStyleCategoryPrefix } from '../../category-page-algolia/categoryPageSlugUtils';
const ProductCardStaticUI = t0 => {
  const $ = _c(96);
  const {
    analyticsComponentName,
    disableImageLazyLoading,
    disablePDPPrefetch: t1,
    prioritizeImage,
    hidden,
    enableMobileCarousel,
    onClick,
    onProductClicked,
    isHotspotCard: t2,
    layout
  } = t0;
  const disablePDPPrefetch = t1 === undefined ? false : t1;
  const isHotspotCard = t2 === undefined ? false : t2;
  const history = useHistory();
  const location = useLocation();
  const {
    id,
    image,
    isClearance,
    isOutOfStock,
    label: t3,
    loading,
    minPrice,
    name,
    originalPrice,
    path,
    position,
    price,
    productFamily,
    productLabel,
    productLabelColor,
    productType,
    quickship,
    showAttributes,
    showProductLabel,
    showShowroomInfo,
    showStockInfo,
    showSwatches,
    sku,
    slug,
    upholsteryThumbnail,
    variantsToShow
  } = useProductCardContext();
  const label = t3 === undefined ? "" : t3;
  let t4;
  if ($[0] !== path || $[1] !== slug) {
    t4 = path && String(path) !== "null" && path.startsWith("/") ? path : slug ? `/products/${slug}/` : "#";
    $[0] = path;
    $[1] = slug;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const safePath = t4;
  const currentPage = useUserCurrentPageType();
  const {
    data: clearanceData
  } = useAllProductClearanceStock();
  const closeSearch = useCloseSearch();
  const pathnameSegments = location?.pathname?.split("/").filter(Boolean) ?? [];
  const isStyleCategoryPage = pathnameSegments.length === 2 && isStyleCategoryPrefix(pathnameSegments[0]);
  const shouldDisablePDPPrefetch = disablePDPPrefetch || currentPage === avo.Location.CATEGORY_PAGE || isStyleCategoryPage;
  const isFlashSale = Boolean(clearanceData?.[id]?.[sku]?.flashSale);
  let t5;
  if ($[3] !== analyticsComponentName || $[4] !== currentPage || $[5] !== id || $[6] !== isClearance || $[7] !== isFlashSale || $[8] !== label || $[9] !== name || $[10] !== originalPrice || $[11] !== position || $[12] !== price || $[13] !== productFamily || $[14] !== productType || $[15] !== quickship || $[16] !== sku) {
    t5 = () => {
      avo.productClicked({
        category: productType,
        component: analyticsComponentName,
        contentIds: [(sku ?? "").split("-")[0]],
        currency: "USD",
        fullPrice: parseFloat(originalPrice),
        isClearance,
        location: currentPage,
        name,
        position,
        price: parseFloat(price),
        productFamily,
        productId: id,
        quantity: 1,
        quickship,
        sku,
        variant: label,
        isFlashSale
      });
    };
    $[3] = analyticsComponentName;
    $[4] = currentPage;
    $[5] = id;
    $[6] = isClearance;
    $[7] = isFlashSale;
    $[8] = label;
    $[9] = name;
    $[10] = originalPrice;
    $[11] = position;
    $[12] = price;
    $[13] = productFamily;
    $[14] = productType;
    $[15] = quickship;
    $[16] = sku;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const trackProductClicked = t5;
  let t6;
  if ($[18] !== closeSearch || $[19] !== history || $[20] !== image || $[21] !== minPrice || $[22] !== name || $[23] !== onClick || $[24] !== onProductClicked || $[25] !== originalPrice || $[26] !== price || $[27] !== safePath || $[28] !== trackProductClicked) {
    t6 = event => {
      trackProductClicked(event);
      onProductClicked?.();
      if (event.ctrlKey || event.metaKey) {
        return;
      }
      event.preventDefault();
      onClick?.();
      closeSearch();
      if (safePath.startsWith("/modular/") || safePath.startsWith("/modulars/")) {
        window.location.href = safePath;
      } else {
        if (safePath !== "#") {
          history.push(safePath, {
            image,
            minPrice,
            name,
            originalPrice,
            price
          });
        }
      }
    };
    $[18] = closeSearch;
    $[19] = history;
    $[20] = image;
    $[21] = minPrice;
    $[22] = name;
    $[23] = onClick;
    $[24] = onProductClicked;
    $[25] = originalPrice;
    $[26] = price;
    $[27] = safePath;
    $[28] = trackProductClicked;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const onProductClick = t6;
  const labelStr = label != null ? String(label) : "";
  let t7;
  if ($[30] !== labelStr) {
    t7 = labelStr.split(",")?.[0] ?? "";
    $[30] = labelStr;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  const shortLabel = t7;
  let t8;
  if ($[32] !== labelStr) {
    t8 = labelStr.split(",").slice(1).map(_temp);
    $[32] = labelStr;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  const otherLabels = t8;
  let t9;
  if ($[34] !== hidden || $[35] !== isHotspotCard) {
    t9 = classNames("rounded-sm relative text-gray [transition:all_0.25s_ease-in-out] pb-2 md:pb-0", {
      "!rounded-lg !p-2.5": isHotspotCard
    }, {
      hidden
    });
    $[34] = hidden;
    $[35] = isHotspotCard;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  const t10 = shouldDisablePDPPrefetch ? false : undefined;
  let t11;
  if ($[37] !== disableImageLazyLoading || $[38] !== enableMobileCarousel || $[39] !== prioritizeImage) {
    t11 = <ProductCardPhotoSquare disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} enableMobileCarousel={enableMobileCarousel} />;
    $[37] = disableImageLazyLoading;
    $[38] = enableMobileCarousel;
    $[39] = prioritizeImage;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== name) {
    t12 = <ProductCardNameUI name={name} />;
    $[41] = name;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const t13 = !!price && (!!originalPrice && originalPrice !== price || !!minPrice && minPrice !== price);
  const t14 = originalPrice ?? price;
  let t15;
  if ($[43] !== loading || $[44] !== minPrice || $[45] !== price || $[46] !== t13 || $[47] !== t14) {
    t15 = <ProductCardPriceUI hasDiscount={t13} loading={loading} minPrice={minPrice} originalPrice={t14} salePrice={price} />;
    $[43] = loading;
    $[44] = minPrice;
    $[45] = price;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== t12 || $[50] !== t15) {
    t16 = <div className="min-h-[4.6rem] min-w-0">{t12}{t15}</div>;
    $[49] = t12;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== quickship || $[53] !== showStockInfo) {
    t17 = showStockInfo && !!quickship && <div className="text-xs flex items-center text-gray-light1 mt-1 gap-2"><IconQuickship color={colorGrayLight2} width={18} height={12} /><span>Ready to ship</span></div>;
    $[52] = quickship;
    $[53] = showStockInfo;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== isOutOfStock || $[56] !== showStockInfo) {
    t18 = showStockInfo && !!isOutOfStock && <div className="text-xs text-red mt-1">Out of stock</div>;
    $[55] = isOutOfStock;
    $[56] = showStockInfo;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== t17 || $[59] !== t18) {
    t19 = <div className="shrink-0 xl:mt-5 xl:ml-auto">{t17}{t18}</div>;
    $[58] = t17;
    $[59] = t18;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== t16 || $[62] !== t19) {
    t20 = <div className="flex flex-col gap-1 xl:flex-row xl:items-start xl:gap-x-2 xl:gap-y-0 w-full px-[10px] md:px-0 pb-2 relative">{t16}{t19}</div>;
    $[61] = t16;
    $[62] = t19;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  let t21;
  if ($[64] !== otherLabels || $[65] !== shortLabel || $[66] !== showAttributes || $[67] !== upholsteryThumbnail) {
    t21 = showAttributes && (!!shortLabel || !!otherLabels.length) && <ProductCardOptionsUI fabricSelectedOption={{
      label: shortLabel,
      image: upholsteryThumbnail
    }} productOptions={otherLabels} />;
    $[64] = otherLabels;
    $[65] = shortLabel;
    $[66] = showAttributes;
    $[67] = upholsteryThumbnail;
    $[68] = t21;
  } else {
    t21 = $[68];
  }
  let t22;
  if ($[69] !== productLabel || $[70] !== productLabelColor || $[71] !== showProductLabel) {
    t22 = showProductLabel && !!productLabel && <ProductCardLabelUI label={productLabel} color={productLabelColor} />;
    $[69] = productLabel;
    $[70] = productLabelColor;
    $[71] = showProductLabel;
    $[72] = t22;
  } else {
    t22 = $[72];
  }
  let t23;
  if ($[73] !== layout) {
    t23 = layout !== "mini" && <div className="absolute top-5 right-5 group-hover:opacity-100"><ProductCardFavoriteButton /></div>;
    $[73] = layout;
    $[74] = t23;
  } else {
    t23 = $[74];
  }
  let t24;
  if ($[75] !== name || $[76] !== onProductClick || $[77] !== safePath || $[78] !== t10 || $[79] !== t11 || $[80] !== t20 || $[81] !== t21 || $[82] !== t22 || $[83] !== t23) {
    t24 = <Link onClick={onProductClick} to={safePath} prefetch={t10} aria-label={name} className="block hover:!no-underline group/product-card">{t11}{t20}{t21}{t22}{t23}</Link>;
    $[75] = name;
    $[76] = onProductClick;
    $[77] = safePath;
    $[78] = t10;
    $[79] = t11;
    $[80] = t20;
    $[81] = t21;
    $[82] = t22;
    $[83] = t23;
    $[84] = t24;
  } else {
    t24 = $[84];
  }
  let t25;
  if ($[85] !== onProductClick || $[86] !== showSwatches || $[87] !== variantsToShow?.length) {
    t25 = showSwatches && variantsToShow?.length >= 2 && <TabletAndDesktopOnly><div className="max-[767px]:hidden"><ProductCardSwatchesNewUI onProductClick={onProductClick} /></div></TabletAndDesktopOnly>;
    $[85] = onProductClick;
    $[86] = showSwatches;
    $[87] = variantsToShow?.length;
    $[88] = t25;
  } else {
    t25 = $[88];
  }
  let t26;
  if ($[89] !== showShowroomInfo) {
    t26 = showShowroomInfo && <div className="mt-2"><ProductCardOnDisplayInShowroom /></div>;
    $[89] = showShowroomInfo;
    $[90] = t26;
  } else {
    t26 = $[90];
  }
  let t27;
  if ($[91] !== t24 || $[92] !== t25 || $[93] !== t26 || $[94] !== t9) {
    t27 = <div className={t9}>{t24}{t25}{t26}</div>;
    $[91] = t24;
    $[92] = t25;
    $[93] = t26;
    $[94] = t9;
    $[95] = t27;
  } else {
    t27 = $[95];
  }
  return t27;
};
ProductCardStaticUI.propTypes = {
  analyticsComponentName: PropTypes.string,
  disablePDPPrefetch: PropTypes.bool,
  hidden: PropTypes.bool,
  isHotspotCard: PropTypes.bool,
  enableMobileCarousel: PropTypes.bool,
  onClick: PropTypes.func,
  onProductClicked: PropTypes.func,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom'])
};
export default ProductCardStaticUI;
function _temp(item) {
  return item.trim();
}